import { Injectable, Optional } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {
  OAuthModuleConfig,
  OAuthResourceServerErrorHandler,
  OAuthStorage,
} from 'angular-oauth2-oidc';

import { environment } from '@env/environment';

@Injectable()
export class OAuthInterceptor implements HttpInterceptor {
  constructor(
    private authStorage: OAuthStorage,
    private errorHandler: OAuthResourceServerErrorHandler,
    @Optional() private moduleConfig: OAuthModuleConfig,
  ) {}

  private isUrlAllowed(url: string): boolean {
    const found = this.moduleConfig?.resourceServer?.allowedUrls?.find((u) => url.startsWith(u));
    return !!found;
  }

  private isUrlExcluded(url: string): boolean {
    const excludedUrls = [`${environment.api.nilo.user.root}/users/actions/login`];
    return excludedUrls.some((excludedUrl) => url === excludedUrl);
  }

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const url = req.url.toLowerCase();

    if (!this.isUrlAllowed(url)) return next.handle(req);
    if (this.isUrlExcluded(url)) return next.handle(req);

    const sendAccessToken = this.moduleConfig.resourceServer.sendAccessToken;

    if (sendAccessToken) {
      const token = this.authStorage.getItem('access_token');
      const header = 'Bearer ' + token;
      const headers = req.headers.set('Authorization', header);
      req = req.clone({ headers });
    }

    return next.handle(req).pipe(catchError((err) => this.errorHandler.handleError(err)));
  }
}
